import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

import { type EditorAgent } from '../../utils/agents';

export const useShowBetaLozenge = ({ agent }: { agent?: EditorAgent }): boolean => {
	const convoAIBetaLozenge =
		fg('platform.editor.ai-assistance-service-free-generate') ||
		fg('platform.editor.ai-interrogate-with-convo-ai');
	const newPaletteFlag = editorExperiment('platform_editor_ai_command_palate_improvement', 'test');
	const rovoBetaLozenge = newPaletteFlag ? !agent : true;
	const showBetaLozenge = convoAIBetaLozenge && rovoBetaLozenge;
	return showBetaLozenge;
};
